import React from 'react'
import styles from './MailSettingsForm.module.css'
import { useTranslation } from 'react-i18next'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import { ScheduledEmailsFrequencyOptions } from 'components/Order/constants'
import { OrderEmailsLanguage } from 'services'
import { Tooltip } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { ORDER_REPORT_SETTINGS_READ, ORDER_REPORT_SETTINGS_WRITE, useAuth } from 'context/auth'

export function MailSettingsForm () {
  const { t } = useTranslation()
  const { values } = useFormikContext()
  const { hasAnyPrivileges } = useAuth()
  const visible = hasAnyPrivileges([ORDER_REPORT_SETTINGS_READ])
  if (!visible) return null

  const disabled = !hasAnyPrivileges([ORDER_REPORT_SETTINGS_WRITE])
  const scheduledEmailsDisabled = values.emailNotificationSettings.scheduledEmailsDisabled
  const tooltipText = scheduledEmailsDisabled
    ? t('form.emailNotificationSetting.sendInterval.disabledTooltip')
    : ''

  return (
    <div className={styles.mailContainer}>
      <div className={styles.mailFormContainer}>
        <div>{t('form.emailNotificationSetting.label')}</div>
        <Tooltip title={tooltipText}>
          <div>
            <ControlledSelectField
              options={Object.values(ScheduledEmailsFrequencyOptions)}
              getOptionLabel={opt => t(opt.label)}
              getOptionValue={opt => opt}
              label={t('form.emailNotificationSetting.sendInterval.title')}
              fieldName="emailNotificationSettings.scheduledEmailsFrequency"
              className={styles.intervalField}
              disabled={scheduledEmailsDisabled || disabled}
              disableClear
            />
          </div>
        </Tooltip>
        <div>
          <ControlledSelectField
            options={Object.values(OrderEmailsLanguage)}
            getOptionLabel={opt => opt}
            getOptionValue={opt => opt}
            label={t('form.emailNotificationSetting.language.title')}
            fieldName="emailNotificationSettings.language"
            className={styles.languageField}
            disabled={disabled}
            disableClear
          />
        </div>
      </div>
    </div>
  )
}
